<template>
  <v-container fluid style="height: 100%;" class="pl-0 pr-2 py-0 m-0 box" align-stretch>
    <v-layout row wrap ma-0 py-4 justify-start>
      <v-flex xs12>
        <p class="font-weight-medium my-0 ml-4 pl-4">รถโดยสารและรถบรรทุกที่เกิดเหตุ</p>
        <v-card
          class="d-flex justify-start ma-0 my-2 px-2"
          :class="[{ row: $vuetify.breakpoint.smAndDown }, { 'pl-4': $vuetify.breakpoint.mdAndUp }]"
          flat
        >
          <v-flex :class="[$vuetify.breakpoint.mdAndUp ? 'col-3' : 'col-12']">
            <v-card class="rectangle2 ml-0">
              <highcharts class="charts-pie" :options="chartPieOptions" ref="chart"></highcharts>
            </v-card>
          </v-flex>
          <v-flex
            class="py-3"
            v-for="(item, i) in causes"
            :key="i"
            :class="[
              { 'desktop-tile': $vuetify.breakpoint.lgAndUp },
              { 'tablet-tile': $vuetify.breakpoint.mdOnly },
              { 'ml-3': i != 0 && $vuetify.breakpoint.mdAndUp },
              { 'col-12 mb-4': $vuetify.breakpoint.smAndDown }
            ]"
          >
            <v-card class="rectangle2 ml-0">
              <div>
                <p class="subtitle-2 text-center mt-3 mb-1 title-cause">{{ item.name }}</p>
              </div>
              <div class="pa-0 px-2">
                <v-flex ma-0 flex-row justify-center>
                  <v-flex xs12>
                    <v-img
                      class="sub-menu"
                      height="36"
                      width="36"
                      :src="getDLTTypeImage(item.id)"
                    ></v-img>
                  </v-flex>
                  <v-flex xs12 text-center>
                    <p class="font-weight-medium my-0 title number">
                      {{ item.accident_count | numFormat }} คัน
                    </p>
                    <p class="caption mb-0">{{ item.percentage }}</p>
                  </v-flex>
                </v-flex>
              </div>
              <v-row class="ma-0 pt-6 mb-1 text-center cause-casualty">
                <v-col cols="6" class="pa-0">
                  <div class="text-center">
                    <v-img
                      contain
                      height="32"
                      :src="require('@/assets/icons/death.svg')"
                      class="ma-0 mt-2"
                    ></v-img>
                    <!-- <i :class="`fas fa-dizzy fa-2x`" class="ma-0 mt-2"></i> -->
                  </div>
                  <p class="font-weight-medium subtitle-1 my-0">{{ item.dead | numFormat }}</p>
                  <p class="subtitle-2 my-0">คน</p>
                </v-col>
                <v-col cols="6" class="pa-0">
                  <div class="text-center">
                    <v-img
                      contain
                      height="32"
                      :src="require('@/assets/icons/user-injured-solid.svg')"
                      class="ma-0 mt-2"
                    ></v-img>
                  </div>
                  <p class="font-weight-medium subtitle-1 my-0">{{ item.injury | numFormat }}</p>
                  <p class="subtitle-2 my-0">คน</p>
                </v-col>
              </v-row>
            </v-card>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'DLTType',
  props: {
    searchCondition: {
      type: Object
    },
    summary: {
      type: Object
    }
  },
  data: () => ({
    title: 'รถโดยสารและรถบรรทุกที่เกิดเหตุ',
    chartPieOptions: null,
    colors: ['#f3a055', '#758f39'],
    causes: [],
    characters: [],
    vehicles: []
  }),
  created() {
    this.initData();
    this.getChartOptions();
    const scope = this;
    window.resizeDLTTimeOut = () => {
      if (window.resizeDLTChart) {
        clearTimeout(window.resizeDLTChart);
      }
      window.resizeDLTChart = setTimeout(() => {
        scope.$refs.chart.chart.reflow();
      }, 500);
    };
    window.addEventListener('resize', window.resizeDLTTimeOut);
  },
  mounted() {},
  destroyed() {
    window.removeEventListener('resize', window.resizeDLTTimeOut);
  },
  computed: {},
  methods: {
    init() {
      this.search();
    },
    getChartOptions() {
      this.chartPieOptions = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
          height: 260,
          style: {
            fontFamily: 'Kanit'
          }
        },
        title: {
          text: null
        },
        xAxis: {
          crosshair: true
        },
        yAxis: {
          title: null
        },
        legend: {
          align: 'center',
          verticalAlign: 'bottom',
          x: 0,
          y: -20
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '{point.y:,.0f} คัน',
              distance: 0
            },
            showInLegend: true
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">จำนวนอุบัติเหตุ</span><br/>',
          pointFormat: '{point.name}: <b>{point.y:,.0f} ครั้ง</b>'
        },
        colors: null,
        series: {
          data: []
        }
      };
    },
    initData() {
      const initCause = {
        name: '--',
        accident_count: 0,
        percentage: '',
        dead: 0,
        injury: 0
      };
      this.causes = [initCause, initCause];
    },
    search() {
      this.initData();
      this.searchCause();
      if (this.$refs.chart) {
        this.$refs.chart.chart.reflow();
      }
    },
    searchCause() {
      if (!(this.searchCondition && this.searchCondition.isBMTA)) {
        return;
      }
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/dashboard/dlt/type`;

      this.axios
        .get(url, { params: this.searchCondition })
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.causes = response.data.data;
            scope.$emit('showDLT', scope.causes.length > 0);
            scope.$emit('getSummaryDLT', response.data.data);
          }
        })
        .catch(error => { console.log(error); });
    },
    getDLTTypeImage(id) {
      if (id === 220) {
        return require('@/assets/icons/bus.svg');
      }

      return require('@/assets/icons/trailer.svg');
    }
  },
  watch: {
    searchCondition() {
      this.search();
    },
    causes() {
      const damage = [];
      this.chartPieOptions.colors = this.colors.slice(0, this.causes.length);
      this.causes.forEach((cause, i) => {
        damage.push({ name: cause.name, y: cause.accident_count });
      });
      this.chartPieOptions.series.data = damage;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
  background-color: white;
}

.col {
  padding: 0;
}

.v-tab {
  background-color: white;
  color: #ba4438;
}

.v-tab.v-tab--active {
  background-color: #ba4438;
  color: white;
}

.search {
  float: right;
}

.detail {
  background: var(--v-brightgrey-base);
}

.number {
  color: #ba4438;
}

.chart {
  margin-top: 10px;
  margin-bottom: 10px;
}

.sub-menu {
  width: 32px;
  height: 32px;
  margin: auto;
  top: calc(50% - 16px);
}

.rectangle1 {
  min-width: 110px;
  height: 210px;
  border-radius: 3px;
  border: solid 1px #979797;
}

.rectangle2 {
  width: 100%;
  height: 240px;
  border-radius: 3px;
  border: solid 1px #979797;
}

.charts {
  height: 150px;
}

.charts-pie {
  height: 230px;
}

.cause-casualty {
  bottom: 0px;
  position: absolute;
  width: 100%;
}

.title-cause {
  height: 40px;
}

.injury-icon {
  height: 40px;
}

.desktop-tile {
  max-width: 240px;
}

.tablet-tile {
  max-width: 200px;
}
</style>
